// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorAlert_wrapper__7VUBh","heading":"ErrorAlert_heading__Llr5i","retryBtn":"ErrorAlert_retryBtn__ONF4s"};